<template>
  <div>
    <label
      v-if="!imageRendered"
      for="input-file-image"
      class="drop-area"
      @dragover.prevent
      @drop="handleDrop"
      @click="openFileInput"
    >
      Solte a imagem aqui
    </label>
    <input
      id="input-file-image"
      type="file"
      hidden
      @change="handleFileInput"
    >
    <div
      class="d-flex justify-content-center flex-column"
    >
      <img
        v-if="imageRendered"
        :src="renderedImage"
        class="mt-3"
        height="300"
        width="300"
        alt="Imagem Renderizada"
      >
      <a
        v-if="imageRendered"
        id="btn-remove"
        style="text-decoration: underline"
        @click="limparImagem"
      >
        Remover imagem
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    renderedImage: {
      type: String,
      default: '',
    },
    imageRendered: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    limparImagem() {
      this.renderedImage = ''
      this.imageRendered = false
    },
    handleDrop(event) {
      console.log(event)
      event.preventDefault()
      this.$emit('atualizarImagem', event.dataTransfer.files[0])
      // Obtém a imagem do evento de drop
      const file = event.dataTransfer.files[0]

      // Verifica se é uma imagem
      if (file.type.startsWith('image/')) {
        const reader = new FileReader()

        reader.onload = () => {
          this.renderedImage = reader.result
          this.imageRendered = true
        }

        reader.readAsDataURL(file)
        console.log(reader)
      }
      // Lógica para processar o drop de imagem
    },
    openFileInput() {
      this.$refs.fileInput.click() // Abre o diálogo de seleção de arquivo
    },
    handleFileInput(event) {
      this.$emit('atualizarImagem', event.target.files[0])
      const file = event.target.files[0]
      console.log(file)
      if (file) {
        // Lógica para lidar com o arquivo selecionado
        this.renderImageFromFile(file)
      }
    },
    renderImageFromFile(file) {
      console.log('RENDERIZA IMAGEM', file)
      if (file.type.startsWith('image/')) {
        const reader = new FileReader()

        reader.onload = () => {
          this.renderedImage = reader.result
          this.imageRendered = true
        }

        reader.readAsDataURL(file)
      }
    },
    closeFileInput() {
      const fileInput = document.getElementById('input-file-image')
      fileInput.value = ''
    },
  },
}
</script>

<style scoped>
.drop-area {
  width: 200px;
  height: 200px;
  border: 2px dashed #ccc;
  text-align: center;
  line-height: 200px;
  cursor: pointer; /* Adicione um cursor para indicar que é clicável */
}
</style>
